export default function Marquee({ items, className = "", speed = "slow" }) {
  const repeated = [...items, ...items, ...items, ...items];
  return (
    <div className={`relative overflow-hidden w-full ${className}`} data-testid="client-marquee">
      <div className={speed === "fast" ? "flex w-max animate-marquee-fast" : "flex w-max animate-marquee"}>
        {repeated.map((it, i) => (
          <div
            key={i}
            className="px-10 py-6 text-3xl md:text-5xl font-display uppercase tracking-tight text-black transition-colors duration-300 hover:text-[#F42B29] cursor-default"
            data-cursor="client"
          >
            {it}
            <span className="inline-block w-2 h-2 align-middle ml-10 bg-black rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
